// extracted by mini-css-extract-plugin
export default {"menuContainer":"Dropdown_menuContainer__0Ams+","menu":"Dropdown_menu__AT+qL","menuActive":"Dropdown_menuActive__xoKHs","menuTrigger":"Dropdown_menuTrigger__pzevO"};